export const NAME = 'App';
